export const EU_VAT_RATES = {
    AT: 0.2,
    BE: 0.21,
    BG: 0.2,
    CY: 0.19,
    CZ: 0.21,
    DE: 0.19,
    DK: 0.25,
    EE: 0.22,
    ES: 0.21,
    FI: 0.255,
    FR: 0.2,
    GR: 0.24,
    HR: 0.25,
    HU: 0.27,
    IE: 0.23,
    IT: 0.22,
    LT: 0.21,
    LU: 0.17,
    LV: 0.21,
    MT: 0.18,
    NL: 0.21,
    PL: 0.23,
    PT: 0.23,
    RO: 0.19,
    SE: 0.25,
    SI: 0.22,
    SK: 0.2,
};
export const EU_COUNTRIES = new Set(Object.keys(EU_VAT_RATES));
export function getVATRate(countryCode) {
    const normalizedCode = countryCode.toUpperCase();
    if (EU_VAT_RATES[normalizedCode] !== undefined) {
        return EU_VAT_RATES[normalizedCode];
    }
    return 0;
}
export function isEUCountry(countryCode) {
    return EU_COUNTRIES.has(countryCode.toUpperCase());
}
export function getVATRatePercentage(countryCode) {
    return Math.round(getVATRate(countryCode) * 100);
}
export function isValidCountryCode(countryCode) {
    return /^[A-Z]{2}$/.test(countryCode);
}
//# sourceMappingURL=vat-rates.constants.js.map